import {InputController} from './InputController';

Hop.defineModule('m-input', (root, params) => {
    const $input = root.querySelector('input:not([hidden])');
    let input;

    if (!$input) {
        throw Error('input element is missing in your module');
    }

    function loadInputController() {
        removeFallBackStyle();
        input = new InputController(root, $input, params);
        input.initialize();
        return Promise.resolve(input);
    }

    function loadInputDateController() {
        return import(/* webpackChunkName: "input-date" */ './InputDateController').then(({InputDateController}) => {
            removeFallBackStyle();
            input = new InputDateController(root, $input, params);
            input.initialize();
            return input;
        });
    }

    function applyFallbackStyle() {
        root.classList.add('input-fallback');
    }

    function removeFallBackStyle() {
        root.classList.remove('input-fallback');
    }

    const type = $input.getAttribute('type') || 'text';
    const loadPromise = type === 'date' ? loadInputDateController() : loadInputController();
    const promise = loadPromise.catch((e) => {
        // Please note that input date won't have necessarily a dd/mm/yyyy format, depending on your OS lang
        console.error(`Cannot load chunk for input ${type}`);
        console.error(e);
        applyFallbackStyle();

        return Promise.reject(e);
    });

    return promise.then((input) => {
        return function destroy() {
            input.destroy();
        };
    });
});


